import { Box } from "@mui/material";
import * as React from "react";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Button from "@mui/material/Button";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import emailjs from "@emailjs/browser";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// https://mailtrap.io/blog/javascript-contact-form/

interface PropType {}
interface StateType {
  senderInfo: {
    name: string;
    email: string;
    message: string;
    time?: string;
  };
  isEmailVaild: boolean;
  SuccessNotice: boolean;
  messageInProgress: boolean;
}

class LytContactPage extends React.Component<PropType, StateType> {
  state = {
    senderInfo: {
      name: "",
      email: "",
      message: "",
      time: "",
    },
    isEmailVaild: true,
    SuccessNotice: false,
    messageInProgress: false,
  };

  serviceId: string = "service_qc31aw5";
  toTemplateId: string = "template_uedq43t";
  reciptTemplateId: string = "template_zw3woke";
  publicKey: string = "0GNLd3HeON2WFxWB1";

  componentDidMount = () => {};

  handleInputChange = (e) => {
    const targId: string = e.target.id;
    if (targId === "senderName") {
      this.setState({
        senderInfo: {
          name: e.target.value,
          email: this.state.senderInfo.email,
          message: this.state.senderInfo.message,
        },
      });
    } else if (targId === "senderEmail") {
      this.setState({
        senderInfo: {
          name: this.state.senderInfo.name,
          email: e.target.value,
          message: this.state.senderInfo.message,
        },
      });
    } else if (targId === "senderMessage") {
      this.setState({
        senderInfo: {
          name: this.state.senderInfo.name,
          email: this.state.senderInfo.email,
          message: e.target.value,
        },
      });
    }
  };

  isValidEmail = (email) => {
    // Define the JS Regex pattern for a valid email address
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    // Test the email against the pattern and return the result (true or false)
    return emailRegex.test(email);
  };

  handleSubmission = (e) => {
    this.setState(
      {
        isEmailVaild: this.isValidEmail(this.state.senderInfo.email),
      },
      () => {
        if (this.state.isEmailVaild) {
          this.setState(
            {
              messageInProgress: true,
            },
            () => {
              this.sendMessageEmail().then(() => {
                this.sendReceiptEmail();
              });
            }
          );
        }
      }
    );
  };

  sendMessageEmail() {
    return new Promise((resolve, reject) => {
      emailjs
        .send(
          this.serviceId,
          this.toTemplateId,
          this.state.senderInfo,
          this.publicKey
        )
        .then((response) => {
          console.log("email success", response);
          resolve(1);
        })
        .catch((error) => {
          console.error("Error sending email, error");
          alert("Failed to send email :(");
          reject(0);
        });
    });
  }

  sendReceiptEmail() {
    return new Promise((resolve, reject) => {
      emailjs
        .send(
          this.serviceId,
          this.reciptTemplateId,
          this.state.senderInfo,
          this.publicKey
        )
        .then((response) => {
          console.log("email success", response);

          this.setState(
            {
              senderInfo: {
                name: "",
                email: "",
                message: "",
              },
              isEmailVaild: true,
              SuccessNotice: true,
              messageInProgress: false,
            },
            () => {
              resolve(1);
            }
          );
        })
        .catch((error) => {
          console.error("Error sending email, error");
          alert("Failed to send email :(");
          resolve(0);
        });
    });
  }

  handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ SuccessNotice: false });
  };

  render() {
    const buildPageContent = () => {
      if (this.state.messageInProgress) {
        return buildLoadingMessage();
      }
      return buildFormPage();
    };

    const buildFormPage = () => {
      return (
        <FormGroup>
          <FormControl>
            <TextField
              id="senderName"
              label="Your Name"
              className="contactField"
              value={this.state.senderInfo.name}
              aria-describedby="Your Name"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <BadgeOutlinedIcon></BadgeOutlinedIcon>
                    </InputAdornment>
                  ),
                },
                htmlInput: { maxLength: 100 },
              }}
              onChange={this.handleInputChange}
            />
          </FormControl>
          <br />
          <FormControl>
            <TextField
              error={!this.state.isEmailVaild}
              helperText={!this.state.isEmailVaild ? "this seems wrong" : ""}
              value={this.state.senderInfo.email}
              label="Email address"
              className="contactField"
              id="senderEmail"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutlineIcon></MailOutlineIcon>
                    </InputAdornment>
                  ),
                },
                htmlInput: { maxLength: 254 },
              }}
              aria-describedby="Your Email"
              onChange={this.handleInputChange}
            />
          </FormControl>
          <br />
          <FormControl>
            <TextField
              id="senderMessage"
              label="Send me a short message"
              className="contactField"
              value={this.state.senderInfo.message}
              onChange={this.handleInputChange}
              rows={6}
              multiline
            />
          </FormControl>
          <br />
          <Button
            className="contactSubButton"
            onClick={this.handleSubmission}
            variant="outlined"
          >
            Send
          </Button>
        </FormGroup>
      );
    };

    const buildLoadingMessage = () => {
      return (
        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          })}
          open={true}
        >
          <p id="emailSendingNotice">
            Email is being sent, this may take a minute or five...
          </p>
          <br />
          <CircularProgress id="emailSendingSpinner" color="inherit" />
        </Backdrop>
      );
    };

    return (
      <Box id="lytContactPageWrapper">
        {buildPageContent()}
        <Snackbar
          open={this.state.SuccessNotice}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose}
        >
          <Alert
            onClose={this.handleSnackbarClose}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            Message Received!
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default LytContactPage;
